import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';

interface GetQuantifyCompareQueryOptions {
  shouldIncludeDashboardFilters?: boolean;
}

export const useGetQuantifyCompareQuery = ({
  shouldIncludeDashboardFilters = true,
}: GetQuantifyCompareQueryOptions = {}) => {
  return useQuantifyStore(({ query, visual }) => {
    return shouldIncludeDashboardFilters
      ? visual.quantifyAndDashboardFilters.compareQuery ?? query.compareQuery
      : query.compareQuery;
  });
};
